import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
  Avatar,
  Chip,
  Button,
} from "@mui/material";

import "./fade-animations.css";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PaperliveLogo from '../../Header/paperlive_only_p.png';
import { EXECUTIVE_PG_DEVOPS_PROGRAM, EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT } from "../../constants/AzureDevops";
import PaperliveXIITPatnaSmall from "../images/PaperliveXIITPatnaSmall.webp";

const devopsCourses = [
  { title: EXECUTIVE_PG_DEVOPS_PROGRAM, subtitle: "Paperlive Learning | Microsoft & AWS", img: PaperliveLogo, url: "/devops-training-online" },
  { title: "DevOps and Cloud with GenAI Master Program", subtitle: "Paperlive Learning | Microsoft", img: PaperliveLogo, url: "/devops-and-cloud-training-online" },
  { title: "DevOps Certification Training", subtitle: "Paperlive Learning", img: PaperliveLogo, url: "/devops-certification-training" },
  { title: "AWS Certification Training", subtitle: "Paperlive Learning", img: PaperliveLogo, url: "/aws-solution-architect" },
  { title: "Azure Certification Training", subtitle: "Paperlive Learning | Microsoft", img: PaperliveLogo, url: "/microsoft-azure" },
  { title: "GCP Certification Training", subtitle: "Paperlive Learning", img: PaperliveLogo, url: "/google-cloud-platform" },
];

const fullstackCourses = [
  { title: "Full Stack Web Development with GenAI", subtitle: "Paperlive Learning | Microsoft", tag: "New", img: PaperliveLogo, url: "/full-stack-web-development" },
];

const dataScienceCourses = [
  { title: "AI and Data Science Master Program", subtitle: "Paperlive Learning | Microsoft", img: PaperliveLogo, url: "/data-science-training-online" },
];

const NavbarMobile = ({ scrollToSection, course }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openDevops, setOpenDevops] = useState(false);
  const [openFullstack, setOpenFullstack] = useState(false);
  const [openDataScience, setOpenDataScience] = useState(false);

  const navigate = (url) => {
    window.location.href = url;
    setDrawerOpen(false);
  };

  return (
    <>
      {/* Top Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
        <img style={{mixBlendMode: 'multiply'}} src={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? PaperliveLogo : PaperliveLogo} alt="Paperlive" height={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? "24" :"24"} width={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? "26" :"26"} onClick={() => !(course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) && (window.location.href = "/")}/>
        <IconButton onClick={() => setDrawerOpen(true)} aria-label="Open Menu">
          <MenuIcon />
        </IconButton>
      </Box>

      {/* Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: "80%", maxWidth: 380, pt: 0, background: "#fdfcff" } }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1.5} sx={{ borderBottom: "1px solid #e5e7eb" }}>
          <img src={PaperliveLogo} alt="Paperlive" height="24" loading="lazy"/>
          <IconButton onClick={() => setDrawerOpen(false)} aria-label="Close Menu">
            <CloseIcon />
          </IconButton>
        </Box>

        <div className="fade-in-025">
          {! (course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) && <><List sx={{ mt: 1, maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
            {/* COURSES Header */}
            <ListItemButton onClick={() => setOpenDevops(!openDevops)}>
              <ListItemText
                primary="DevOps"
                primaryTypographyProps={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8rem", color: "#8C00FF" }}
              />
              {openDevops ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openDevops} timeout="auto" unmountOnExit>
              <Box sx={{ px: 2 }}>
                {devopsCourses.map((c) => (
                  <Box
                    key={c.title}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={0.8}
                    p={0.5}
                    sx={{
                      borderRadius: 2,
                      cursor: "pointer",
                      transition: ".2s",
                      "&:hover": { background: "#f9f6ff", transform: "translateX(2px)" },
                    }}
                    onClick={() => navigate(c.url)}
                  >
                    <Avatar src={c.img} sx={{ width: 32, height: 32, bgcolor: "#000", '& img': { width: '60%', height: '60%', filter: 'invert(1)' } }} />
                    <Box>
                      <Typography fontFamily="Poppins" fontWeight={600} fontSize="0.75rem">{c.title}</Typography>
                      <Typography fontFamily="Poppins" fontSize="0.6rem" color="text.secondary" sx={{ opacity: 0.8 }}>{c.subtitle}</Typography>
                      {c.tag && <Chip label={c.tag} size="small" sx={{ mt: 0.2, fontSize: "0.55rem", fontWeight: 500, borderRadius: 1, background: "linear-gradient(90deg, #8C00FF, #C000FF)", color: "#fff" }} />}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Collapse>

            {/* Full Stack */}
            <ListItemButton onClick={() => setOpenFullstack(!openFullstack)}>
              <ListItemText
                primary="Full Stack"
                primaryTypographyProps={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8rem", color: "#8C00FF" }}
              />
              {openFullstack ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openFullstack} timeout="auto" unmountOnExit>
              <Box sx={{ px: 2 }}>
                {fullstackCourses.map((c) => (
                  <Box
                    key={c.title}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={0.8}
                    p={0.5}
                    sx={{
                      borderRadius: 2,
                      cursor: "pointer",
                      transition: ".2s",
                      "&:hover": { background: "#f9f6ff", transform: "translateX(2px)" },
                    }}
                    onClick={() => navigate(c.url)}
                  >
                    <Avatar src={c.img} sx={{ width: 32, height: 32, bgcolor: "#000", '& img': { width: '60%', height: '60%', filter: 'invert(1)' } }} />
                    <Box>
                      <Typography fontFamily="Poppins" fontWeight={600} fontSize="0.75rem">{c.title}</Typography>
                      <Typography fontFamily="Poppins" fontSize="0.6rem" color="text.secondary" sx={{ opacity: 0.8 }}>{c.subtitle}</Typography>
                      {c.tag && <Chip label={c.tag} size="small" sx={{ mt: 0.2, fontSize: "0.55rem", fontWeight: 500, borderRadius: 1, background: "linear-gradient(90deg, #8C00FF, #C000FF)", color: "#fff" }} />}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Collapse>

            {/* Data Science */}
            <ListItemButton onClick={() => setOpenDataScience(!openDataScience)}>
              <ListItemText
                primary="Data Science"
                primaryTypographyProps={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8rem", color: "#8C00FF" }}
              />
              {openDataScience ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openDataScience} timeout="auto" unmountOnExit>
              <Box sx={{ px: 2 }}>
                {dataScienceCourses.map((c) => (
                  <Box
                    key={c.title}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={0.8}
                    p={0.5}
                    sx={{
                      borderRadius: 2,
                      cursor: "pointer",
                      transition: ".2s",
                      "&:hover": { background: "#f9f6ff", transform: "translateX(2px)" },
                    }}
                    onClick={() => navigate(c.url)}
                  >
                    <Avatar src={c.img} sx={{ width: 32, height: 32, bgcolor: "#000", '& img': { width: '60%', height: '60%', filter: 'invert(1)' } }} />
                    <Box>
                      <Typography fontFamily="Poppins" fontWeight={600} fontSize="0.75rem">{c.title}</Typography>
                      <Typography fontFamily="Poppins" fontSize="0.6rem" color="text.secondary" sx={{ opacity: 0.8 }}>{c.subtitle}</Typography>
                      {c.tag && <Chip label={c.tag} size="small" sx={{ mt: 0.2, fontSize: "0.55rem", fontWeight: 500, borderRadius: 1, background: "linear-gradient(90deg, #8C00FF, #C000FF)", color: "#fff" }} />}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Collapse>

            <Divider sx={{ my: 1 }} />

            {/* Blog */}
            <ListItemButton onClick={() => navigate("/blog")}>
              <ListItemText primary="Blog" primaryTypographyProps={{ fontFamily: "Poppins", fontSize: "0.75rem" }} />
            </ListItemButton>

            {/* Invite */}
            <ListItemButton onClick={() => scrollToSection("refer")}>
              <ListItemText primary="Invite & Earn" primaryTypographyProps={{ fontFamily: "Poppins", fontSize: "0.75rem" }} />
            </ListItemButton>
          </List></>}

          {/* Call Button */}
          <Box px={2} mt="auto" mb={2}>
            <Button 
            aria-label="Call Now"
            fullWidth 
            onClick={() => window.open("tel:+918197868030", "_self")}
            variant="contained" sx={{ background: "#000", "&:hover": { background: "#4c1d95" }, borderRadius: 2, fontFamily: "Poppins", fontSize: "0.75rem", fontWeight: 600, py: 0.7 }}>
              <LocalPhoneIcon sx={{ mr: 1, fontSize: 16 }} /> +91 8197868030
            </Button>
          </Box>
        </div>
      </Drawer>
    </>
  );
};

export default NavbarMobile;
